import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';
import { User } from '../shared/models/User';

@Component({
  selector: 'app-authorized',
  templateUrl: './authorized.component.html',
  styleUrls: ['./authorized.component.scss']
})
export class AuthorizedComponent implements OnInit {
  user: User;
  loginMenu = {
    userFullname: '',
    organizationId: 0,
    isOpen: false
  };

  constructor(private router: Router
    , private authService: AuthService) {
      this.user = AuthService.currentUser();
    }

  ngOnInit() {
    this.loginMenu.userFullname = AuthService.currentUser().name;
    this.loginMenu.organizationId = AuthService.currentUser().organizationId;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/authorized.component.ts